/**
 * @file Shared HUD/menu surface: near-black card with a hairline border. Every
 * HUD chrome piece (TimeOfDay's expanded panel, PerfBadge, DebugPanel) sits on
 * one of these so the whole overlay reads as one system. Colours come from the
 * `@theme` tokens in `src/styles.css` — never hard-code a hex here.
 */
export default function Panel({ className = '', children, ...rest }) {
  return (
    <div className={`rounded-md border border-hairline bg-ink/90 backdrop-blur-sm ${className}`} {...rest}>
      {children}
    </div>
  );
}
